import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Select, MenuItem } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import BootstrapInput from './BootstrapInput';

const useStyles = makeStyles((theme) => ({
  selectRoot: {
    display: 'inline-flex',
  },
  input: {
    borderColor: (props) => (props.error ? theme.palette.error.main : '#ced4da'),
  },
}));

const MySelect = (props) => {
  const {
    name,
    value,
    onChange,
    defaultValue,
    inputRef,
    menuItems,

    autoFocus,
    disabled,
    error,
  } = props;
  const classes = useStyles({ error });

  const menus = menuItems.map((m) => (
    <MenuItem
      key={`menu-item-${name}-${m.value}`}
      value={m.value}
    >
      {m.label ? m.label : <FormattedMessage id={m.labelId} />}
    </MenuItem>
  ));

  return (
    <Select
      inputRef={inputRef}
      classes={{ root: classes.selectRoot }}
      value={value}
      defaultValue={defaultValue}
      input={(
        <BootstrapInput
          classes={{ input: classes.input }}
          disabled={disabled}
          name={name}
          onChange={onChange}
          inputProps={{
            autoFocus,
          }}
        />
        )}
    >
      {menus}
    </Select>
  );
};

const mySelectValuePropTypes = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

MySelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: mySelectValuePropTypes,
  defaultValue: mySelectValuePropTypes,
  inputRef: PropTypes.any,
  onChange: PropTypes.func,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    value: mySelectValuePropTypes.isRequired,
    label: PropTypes.string,
    labelId: PropTypes.string,
  })),

  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

MySelect.defaultProps = {
  value: undefined,
  onChange: undefined,
  defaultValue: undefined,
  inputRef: undefined,
  menuItems: [],
  autoFocus: false,
  disabled: false,
  error: false,
};

export default MySelect;
